import { render } from "./contents.vue?vue&type=template&id=4968c882&scoped=true"
const script = {}

import "./contents.vue?vue&type=style&index=0&id=4968c882&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4968c882"]])

export default __exports__